import React from 'react';
import './ui.css';

export type CardVariant = 'default' | 'interactive' | 'ghost';
export type CardPadding = 'none' | 'sm' | 'md';

export interface CardProps {
  variant?: CardVariant;
  padding?: CardPadding;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  children?: React.ReactNode;
  id?: string;
  role?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  padding = 'md',
  onClick,
  children,
  id,
  role,
  tabIndex,
  onKeyDown,
  ...aria
}) => {
  const isInteractive = variant === 'interactive' || onClick;
  const classes = [
    'ui-card',
    `ui-card--padding-${padding}`,
    isInteractive ? 'ui-card--interactive' : '',
    variant === 'ghost' ? 'ui-card--ghost' : '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div
      className={classes}
      onClick={onClick}
      id={id}
      role={role ?? (isInteractive ? 'button' : undefined)}
      tabIndex={tabIndex ?? (isInteractive ? 0 : undefined)}
      onKeyDown={onKeyDown}
      aria-label={aria['aria-label']}
      aria-labelledby={aria['aria-labelledby']}
    >
      {children}
    </div>
  );
};

export default Card;
